import { environment } from "src/environments/environment";
import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of } from "rxjs";

interface LoginRes {
  message: string,
  token: string,
  refreshToken: string
}

interface VerifyCodeRes extends LoginRes {
  code: string
}

@Injectable({
  providedIn: "root",
})
export class AuthService {
  http = inject(HttpClient)
  private readonly firebaseRefreshUrl = `https://securetoken.googleapis.com/v1/token?key=${environment.firebaseApiKey}`;


  sendVerificationCode(email: string, password: string) {
    const endpoint = `${environment.baseUrl}${environment.actions.auth.sendVerificationCode.path}`;
    return this.http.post<LoginRes>(endpoint, { email, password });
  }
  
  verifyCode(email: string, password: string, code: string){
    const endpoint = `${environment.baseUrl}${environment.actions.auth.verifyCode.path}`;
    return this.http.post<VerifyCodeRes>(endpoint, { email, password, code });
  }

  login(email: string, password: string) {
    const endpoint = `${environment.baseUrl}${environment.actions.auth.login.path}`;
    return this.http.post<LoginRes>(endpoint, { Email: email, Password: password });
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  /** Obtiene el refresh token guardado */
  getRefreshToken(): string | null {
    return localStorage.getItem('refreshToken');
  }

  /** Guarda los tokens en localStorage */
  saveAuthTokens(idToken: string, refreshToken: string): void {
    localStorage.setItem('token', idToken);
    localStorage.setItem('refreshToken', refreshToken);
  }
  
  /** Guarda solo el ID token (cuando Firebase no devuelve un nuevo refresh token) */
  saveIdToken(idToken: string): void {
    localStorage.setItem('token', idToken);
  }

  /** Limpia el storage */
  clearTokens(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }

  /** Llama a Firebase para refrescar el ID token usando el refresh token */
  refreshIdToken(): Observable<any> {
    const refreshToken = this.getRefreshToken();
    if (!refreshToken) return of(null);

    const body = new HttpParams()
      .set('grant_type', 'refresh_token')
      .set('refresh_token', refreshToken);

    return this.http.post(this.firebaseRefreshUrl, body.toString(), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    });
  }
}